import React, { FC } from 'react';
import { ChangeArrow } from 'entities/MonitorSales/components/ChangeArrow';

export const VsChange: FC<{ value: number }> = ({ value }) =>
  value === 0 ? (
    <div className="vs-change vs-change--zero">
      <span>—</span>
    </div>
  ) : (
    <div className={`vs-change vs-change--${value > 0 ? 'pos' : 'neg'}`}>
      <span>
        {value > 0 ? '+' : ''}
        {value}%
      </span>
      <ChangeArrow up={value > 0} />
    </div>
  );
